import * as React from 'react';
import {useDispatch} from 'react-redux';

import {colors} from 'shells/colors/colors';
import {getIconDetails} from 'shells/connected-forms/helpers';
import {LoadingPage} from 'shells/loading-page/loading-page';
import {TwoLineMiniCard} from 'shells/two-line/two-line-mini-card';

import type {GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field} from 'nutshell-graphql-types';

import type {FormFieldSchema} from '../../core/nutshell-fields/types';

import {setActiveFieldId} from '../connected-forms-actions';

import {getPreviewTitle, getPreviewSubtitle} from './helpers';

import styles from './connected-forms-preview.module.css';

type Props = {
    htmlUrlPath: string;
    fields: Field[];
    formSchema: FormFieldSchema;
    isFormIgnored: boolean;
};

export function ConnectedFormsPreview(props: Props) {
    const dispatch = useDispatch();

    const activeFields = props.fields.filter((field) => !field.isIgnored);
    const ignoredFields = props.fields.filter((field) => field.isIgnored);

    return (
        <div className={props.isFormIgnored ? styles['container--ignored'] : styles.container}>
            {props.fields.length && props.formSchema ? (
                <>
                    {activeFields.map((field) => {
                        const iconDetails = getIconDetails(field.entityName, field.isIgnored);

                        return (
                            <TwoLineMiniCard
                                key={field.id}
                                icon={iconDetails.icon}
                                iconColor={iconDetails.color}
                                iconSize={16}
                                topRow={getPreviewTitle(field, props.formSchema)}
                                bottomRow={getPreviewSubtitle(field, props.formSchema)}
                                borderColor={field.needsMapping ? colors.orange : undefined}
                                to={props.htmlUrlPath}
                                onClick={() => {
                                    dispatch(setActiveFieldId(field.id));
                                }}
                            />
                        );
                    })}
                    {ignoredFields.length ? (
                        <TwoLineMiniCard
                            topRow={
                                <>
                                    {ignoredFields.length} ignored field
                                    {ignoredFields.length === 1 ? '' : 's'}
                                </>
                            }
                            isGrey={true}
                        />
                    ) : undefined}
                </>
            ) : (
                <>
                    {!props.formSchema ? (
                        <div className={styles.loading}>
                            <LoadingPage />
                        </div>
                    ) : (
                        <div className={styles.empty}>No fields found</div>
                    )}
                </>
            )}
        </div>
    );
}
